import * as _ from 'lodash';
import { take } from 'rxjs/operators';
import { datadogRum } from '@datadog/browser-rum';

import {
  JwtPayload,
  TokenKeeper,
} from '../../../../../../../../frontend/libs/shared/src/lib/services/tokenKeeper';
import { stonlyTrackFn } from '../../../../js/stonly/stonlyCustomProperties';
import { Route } from '../core/routeGuard/applicationRoutesNg.service';
import AptitudeNavService from './aptitudeNav.service';

// TODO: Dump all the sub-nav stuff in the template below after the seller stuff has been made to use the new nav-item
// nav-link, nav-button, etc. instead of building the JSON structure. The transclude div plus the individual controls
// is way more flexible and easy to work with.
class AptitudeNavController {
  static bindings = {
    //
  };

  account;
  featureList;
  tokenPayload: JwtPayload;

  transcludePresent = false;
  environment;
  itemsLeft;
  itemsRight;

  MANAGE_PRICING_PAGE_URL = 'aptitude/seller/SellerManagePricing';
  homeUrl = Route.HOME_LANDING

  constructor(
    private $transclude,
    private $q,
    private $scope,
    private api,
    private AptitudeNav: AptitudeNavService,
    private $location,
  ) {
    'ngInject';

    $transclude((clone) => {
      if (clone.length) {
        this.transcludePresent = true;
      }
    });
  }

  $onInit() {
    var url: string = this.$location.absUrl();
    this.api.users.currentUser().then((account) => {
      this.account = account;
      /* Stonly-12 Changes applied */
      const stonlyUser = this.account.emailAddress;
      if (!url.includes(this.MANAGE_PRICING_PAGE_URL)) {
        // Exluding this page from stonly since is JSX
        stonlyTrackFn(stonlyUser, { isbuyer: this.account.isBuyer });
      }

      // Had to do this because AngularJS design patterns are horrible, the other option was to create a service to call one api.
      datadogRum.setUser({
        email: this.account.emailAddress,
        name: this.account.fullName,
      });
    });

    let featuresPromise = this.api.features
      .getFeatures()
      .then((featureList) => (this.featureList = featureList));

    const tokenDefer = this.$q.defer();
    const tokenPromise = tokenDefer.promise;

    TokenKeeper.getPlatformSingleton()
      .tokenPayload$.pipe(take(1))
      .subscribe((payload) => {
        this.tokenPayload = payload;
        tokenDefer.resolve(payload);
      });

    // Initialize the set of items to be seen in the header.
    this.$q.all([this.api.users.currentUser(),featuresPromise, tokenPromise]).then(([account, featureList, tokenPayload]) => {
      if (account.environment) {
        this.environment = this.AptitudeNav.getEnvironmentInfo(account);
      }

      this.itemsLeft = this.AptitudeNav.getLeftItems(
        account,
        featureList,
        tokenPayload,
      );

      this.itemsRight = this.AptitudeNav.getRightItems(
        account,
        featureList,
        tokenPayload,
      );
    });
  }

  displayName() {
    return this.account?.organization?.name ?? '';
  }

  show(item) {
    return item.test ? item.test() : true;
  }

  available(menu) {
    return _.filter(menu, this.show);
  }

  url(item) {
    if (typeof item.url === 'function') {
      return item.url();
    } else {
      return item.url;
    }
  }
}

// I'm thinking of going to a system where each of the Sub-Nav controls is itself a directive so there's a set of
// different ones which accommodate what's needed for every page. At least for the moment though I'm sticking with the
// handful of controls which initialize anchors, buttons, etc. from data on the subItems passed in.
export const AptitudeNavComponent = {
  bindings: AptitudeNavController.bindings,
  controller: AptitudeNavController,
  template: require('./aptitudeNav.component.html'),
  transclude: {},
};
